module.exports = {
	"description": "The Link component creates a hyperlink to another URL.",
	"methods": [],
	"props": {
		"children": {
			"flowType": {
				"name": "MnrlReactNode"
			},
			"required": false,
			"description": "Content of the Link"
		},
		"href": {
			"flowType": {
				"name": "string"
			},
			"required": false,
			"description": "A URL or a URL fragment that the link points to"
		},
		"element": {
			"flowType": {
				"name": "$FlowFixMe"
			},
			"required": false,
			"description": "Element to be used as the root node - e.g. \"a\" or { ReactRouterLink }",
			"defaultValue": {
				"value": "'a'",
				"computed": false
			}
		},
		"variant": {
			"flowType": {
				"name": "union",
				"raw": "'regular' | 'danger' | 'success' | 'warning'",
				"elements": [
					{
						"name": "literal",
						"value": "'regular'"
					},
					{
						"name": "literal",
						"value": "'danger'"
					},
					{
						"name": "literal",
						"value": "'success'"
					},
					{
						"name": "literal",
						"value": "'warning'"
					}
				]
			},
			"required": false,
			"description": "Available variants",
			"defaultValue": {
				"value": "'regular'",
				"computed": false
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/Link/Link.js
// module id = 1606
// module chunks = 0